import React, { useState } from 'react';
import './Login.css';
import myImage from './img.jpg';
import axios from 'axios';
import { message, Spin } from 'antd';

const LoginPopup = () => {
  const [something, isSomething] = useState(true);
  const [isOpen, setIsOpen] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const showsignup = () => {
    isSomething(!something);
  };
  const openPopup = () => {
    setIsOpen(true);
  };

  const closePopup = () => {
    setIsOpen(false);
    window.location.href = '/'; // Redirect to the default route ("/")
  };
  const handlesignup = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Start loading

    const values = {
      name: name,
      email: email,
      password: password,
    };

    try {
      const res = await axios.post(
        'https://toureila.onrender.com/api/v1/users/register',
        values
      );

      if (res.data.success) {
        message.success('User registered successfully');
        setIsLoading(false); // Stop loading
        window.location.href = '/'; // Redirect to the home page
      } else {
        message.error(res.data.message);
        setIsLoading(false); // Stop loading
      }
    } catch (error) {
      console.log(error);
      message.error('Something went wrong');
      setIsLoading(false); // Stop loading
    }
  };

  const handlelogin = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Start loading

    const values = {
      email: email,
      password: password,
    };

    try {
      const res = await axios.post(
        'https://toureila.onrender.com/api/v1/users/login',
        values
      );

      if (res.data.success) {
        localStorage.setItem('token', res.data.token);
        message.success('Login Successful');
        setIsLoading(false); // Stop loading
        window.location.href = '/'; // Redirect to the home page
      } else {
        message.error(res.data.message);
        setIsLoading(false); // Stop loading
      }
    } catch (error) {
      console.log(error);
      message.error('Invalid Credentials');
      setIsLoading(false); // Stop loading
    }
  };
  

  return (
    <div>
      {/* <button className="btn btn-danger" onClick={openPopup}>
        Open Login
      </button> */}
      {isOpen && (
        <div className="overlay">
          <div className="containerLogin">
            <div className="row">
              <div className="col-lg-6">
                <img src={myImage} alt="Login" className="img-fluid" />
              </div>
              <div className="col-lg-6">
                <div className="form-containerLogin" style={{width:"100%"}}>
                 {something? <form
                    onSubmit={handlelogin}
                    className="needs-validation"
                    style={{ display: 'block' ,width:"100%"}}
                    noValidate>
                    <h3 className="pb-4 text-center">Login</h3>
                    <div className="mb-3">
                      <label htmlFor="Email" className="form-label">
                        Email:
                      </label>
                      <input
                       value={email} onChange={e => setEmail(e.target.value)}
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        required
                      />
                      <div className="invalid-feedback">
                        Please enter your email.
                      </div>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">
                        Password:
                      </label>
                      <input
                       value={password} onChange={e => setPassword(e.target.value)} 
                        type="password"
                        className="form-control"
                        id="password"
                        name="password"
                        required
                      />
                      <div className="invalid-feedback">
                        Please enter your password.
                      </div>
                    </div>
                    <button type="submit"  className="btn btn-danger">
                      Login
                    </button>
                    <span
                      className="form-toggle p-3"
                      role="button"
                      onClick={showsignup}
                    >
                      Or Sign Up
                    </span>
                  </form>:
                  <form
                    method='POST'
                    onSubmit={handlesignup}
                    className="was-validated"
                    style={{ display: 'block' ,width:"100%"}}
                    noValidate
                  >
                    <h2>Sign Up</h2>
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label">
                        Name:
                      </label>
                      <input

                      value={name}  onInput={e => setName(e.target.value)}
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        required
                      />
                      <div className="invalid-feedback">
                        Please enter your name.
                      </div>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">
                        Email:
                      </label>
                      <input
                        value={email}  onInput={e => setEmail(e.target.value)}
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        required
                      />
                      <div className="invalid-feedback">
                        Please enter a valid email address.
                      </div>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">
                        Password:
                      </label>
                      <input
                        value={password} onInput={e => setPassword(e.target.value)}
                        type="password"
                        className="form-control"
                        id="password"
                        name="password"
                        required
                      />
                      <div className="invalid-feedback">
                        Please enter a password.
                      </div>
                    </div>
                    <input type="submit" value="submit" className="btn btn-danger"/>
                      {/* Sign Up
                    </input> */}
                    <span
                      className="form-toggle "
                      role="button"
                      onClick={showsignup}
                    >
                      Or Login
                    </span>
                  </form>
}
                </div>
              </div>
            </div>
            <span
              className="close-btn"
              onClick={closePopup}
              role="button"
            >
              &times;
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPopup;